import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { RestProviderService } from 'src/app/shared/services/rest-provider.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { CatalogoDetalleBean } from 'src/app/_beans/CatalogoDetalleBean';
import { PersonaPideBean } from 'src/app/_beans/PersonaPideBean';
import { UnidadOrganicaBean } from 'src/app/_beans/UnidadOrganicaBean';
import { UsuarioBean } from 'src/app/_beans/UsuarioBean';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-usuario-form',
  templateUrl: './usuario-form.component.html',
  styleUrls: ['./usuario-form.component.scss']
})
export class UsuarioFormComponent  implements OnInit {
  user: UsuarioBean;
  tipoDocumentoDetalleList: CatalogoDetalleBean[] = [];
  entidadList: UnidadOrganicaBean[] = [];
  despachoList: UnidadOrganicaBean[] = [];
  direccionGeneralList: UnidadOrganicaBean[] = [];
  direccionLineaList: UnidadOrganicaBean[] = [];
  areaList: UnidadOrganicaBean[] = [];
  persona: PersonaPideBean;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UsuarioFormComponent>,
    private restProvider: RestProviderService,
    private userService: AuthService,
    private sharedService: SharedService,
    public constantes: ConstantesService,
  ) { }

  ngOnInit(): void {
    this.obtenerEntidades();
    let params = {
      data: {
        id: this.constantes.ID_CATALOGO_TIPO_DOCUMENTO
      }
    }
    this.restProvider.executeHttpMethod("/cdc/bic", params).subscribe((result: any) => {
      this.tipoDocumentoDetalleList = result.datalist;
        if(this.data && this.data.id){
          let params = {
            data: {
              id: this.data.id
            }
          }
          this.restProvider.executeHttpMethod("/uc/oui", params).subscribe((result: any) => {
            this.user = result.data;
            this.user.entidad=new UnidadOrganicaBean();
            this.user.despacho=new UnidadOrganicaBean();
            this.user.direccionGeneral=new UnidadOrganicaBean();
            this.user.direccionLinea=new UnidadOrganicaBean();
            this.user.area=new UnidadOrganicaBean();
            if(this.user.unidadOrganica){
              this.llenarListasUnidadesOrganicas(this.user.unidadOrganica);
            }
          })
        }
        else{
          this.data={};
          this.data.soloLectura=false
          this.user= new UsuarioBean();
          this.user.entidad=new UnidadOrganicaBean();
          this.user.despacho=new UnidadOrganicaBean();
          this.user.direccionGeneral=new UnidadOrganicaBean();
          this.user.direccionLinea=new UnidadOrganicaBean();
          this.user.area=new UnidadOrganicaBean();
        }
    }, error => {
      console.error(error);
    });
  }

  public obtenerEntidades() {
    this.restProvider.executeHttpMethod("/uoc/le", {}).subscribe((result: any) => {
      this.entidadList = result.datalist;
    })
  }

  public llenarListasUnidadesOrganicas(unidadOrganica : UnidadOrganicaBean){
    if(!unidadOrganica.unidadOrganicaPadre){
      this.user.entidad=unidadOrganica
    }else{
      let listaAscendentes:UnidadOrganicaBean[]=[];
      let params = {
        data: {
            id: unidadOrganica.id
        }
      }
      this.restProvider.executeHttpMethod("/uoc/luoa",params).subscribe((result: any) => {
        listaAscendentes = result.datalist;
        listaAscendentes.forEach(uo => {
         if(!uo.nivel){
            this.user.entidad=uo;
         }else{
            switch(uo.nivel){
              case '4':this.user.area=uo;break;
              case '3':this.user.direccionLinea=uo;break;
              case '2':this.user.direccionGeneral=uo;break;
              case '1':this.user.despacho=uo;break;
            }
            this.cargarSelectHijos(uo.unidadOrganicaPadre,uo.unidadOrganicaPadre.nivel,true)
         }
        });
      })
    }
  }

  public cargarSelectHijos(unidadOrganica : UnidadOrganicaBean,nivel:string, fromLoad:boolean){
    let params = {
      data: {
          id: unidadOrganica.id
      }
    }
    this.restProvider.executeHttpMethod("/uoc/luohd", params).subscribe((result: any) => {
      if(nivel){
        switch(nivel){
          case '1':this.direccionGeneralList=result.datalist;
                  if(!fromLoad){
                    this.direccionLineaList=[];
                    this.areaList=[];
                    this.user.direccionLinea=new UnidadOrganicaBean();
                    this.user.area=new UnidadOrganicaBean();
                  }break;
          case '2':this.direccionLineaList=result.datalist;
                  if(!fromLoad){
                    this.areaList=[];
                    this.user.area=new UnidadOrganicaBean();
                  }break;
          case '3':this.areaList=result.datalist;break;
        }
      }else{
        this.despachoList=result.datalist
        if(!fromLoad){
          this.direccionGeneralList=[];
          this.direccionLineaList=[];
          this.areaList=[];
          this.user.direccionGeneral=new UnidadOrganicaBean();
          this.user.direccionLinea=new UnidadOrganicaBean();
          this.user.area=new UnidadOrganicaBean();
        }
      }
    })
  }

  public guardar() {
    if(this.user.area && this.user.area.id){
      this.user.unidadOrganica=this.user.area;
    }else{
      if(this.user.direccionLinea && this.user.direccionLinea.id){
        this.user.unidadOrganica=this.user.direccionLinea;
      }else{
        if(this.user.direccionGeneral && this.user.direccionGeneral.id){
          this.user.unidadOrganica=this.user.direccionGeneral;
        }else{
          if(this.user.despacho && this.user.despacho.id){
            this.user.unidadOrganica=this.user.despacho;
          }else{
            if(this.user.entidad && this.user.entidad.id){
              this.user.unidadOrganica=this.user.entidad;
            }
          }
        }
      }
    }
    if(!this.user.id) {
      this.user.estado=0
    }
    this.user.nombres=this.user.nombres.toUpperCase();
    this.user.apellidoMaterno=this.user.apellidoMaterno.toUpperCase();
    this.user.apellidoPaterno=this.user.apellidoPaterno.toUpperCase();
    if(this.user.perfil==this.constantes.TIPO_USUARIO_ADMINISTRADOR_SISTEMA){
      this.user.unidadOrganica=undefined;
    }
    let params = {
      data: this.user
    }
    this.restProvider.executeHttpMethod("/uc/ad", params).subscribe((result: any) => {
      this.user = result.data;
      this.sharedService.showMessageInfo(result.responseMessage)
      this.userService.usuarioActual.next(this.user);
      this.cerrar();
    })
  }

  public datosCompletados() {
    return !(this.user.nombres && this.user.apellidoMaterno && this.user.apellidoPaterno && this.user.numeroDocumento && this.user.cargo && this.user.numeroTelefono
      &&  this.user.email && this.user.tipoDocumento && this.user.perfil && (this.user.entidad && (this.user.perfil!=this.constantes.TIPO_USUARIO_ADMINISTRADOR_SISTEMA &&  this.user.entidad.id) || (this.user.perfil==this.constantes.TIPO_USUARIO_ADMINISTRADOR_SISTEMA &&  !this.user.entidad.id))  && this.sharedService.validateEmailFormat(this.user.email));
  }

  public limpiarEntidades(){
    if(this.user.perfil==this.constantes.TIPO_USUARIO_ADMINISTRADOR_SISTEMA){
      this.user.entidad.id=undefined;
      this.entidadList=[];
      this.despachoList=[];
      this.direccionGeneralList=[];
      this.direccionLineaList=[];
      this.areaList=[];
    }else{
      if(this.entidadList.length==0){
        this.obtenerEntidades();
      }
    }
  }

  public cerrar() {
    this.dialogRef.close();
  }

  public obtenerDataDni(): void {
    if (this.user.numeroDocumento.trim() != '') {
      let params = {
        data: {
          numeroDocumento: this.user.numeroDocumento
        }
      }
      this.restProvider.executeHttpMethod("/uc/odpd", params).subscribe(result => {
        this.persona = result.data;
        if (this.persona) {
          this.user.nombres=this.persona.snombre;
          this.user.apellidoPaterno=this.persona.spaterno;
          this.user.apellidoMaterno=this.persona.smaterno;
        } else {
          Swal.fire('Error', 'No se encontro Dni en el servicio PIDE', 'error');
          this.user.nombres="";
          this.user.apellidoPaterno="";
          this.user.apellidoMaterno= "";
        }
      }, error => {
        Swal.fire('Error', 'No se pudo obtener datos', 'error');
        console.error(error);
      });
    } else {
      Swal.fire('Error', 'Ingrese DNI', 'error');
    }
  }
}
